const storeLocator = require('../storeLocator/index');
const shippingHelpers = require('./shipping');
const shippingMethodsConfig = require('../../../../config/shippingMethodsConfig.json');
const clientSideValidation = require('../components/clientSideValidation');
const { hideElementsBySelector, showElementsBySelector } = require('../common/utils/dom');

let forceStoresReload = false;

function setForceStoresReload(forceReload = true) {
  forceStoresReload = forceReload;
}

/**
 * Populate store finder html
 * @param {Object} target - Dom element that needs to be populated with store finder
 */
function loadStoreLocator(target) {
  const selectedStoreId = target.data('selectedStoreId');
  const data = {};
  if (selectedStoreId) {
    data.selectedStoreId = selectedStoreId;
  }

  $.ajax({
    url: target.data('url'),
    data,
    method: 'GET',
    success(response) {
      target.html(response.storesResultsHtml);
      initStoreLocator();
      if (selectedStoreId) {
        storeLocator.selectStore(selectedStoreId);
      }
    },
  });
}

/**
 * Init store finder
 */
function initStoreLocator() {
  storeLocator.init();
  if (!$('.results').data('has-results')) {
    $('.store-locator-no-results').show();
  }
  clientSideValidation.submitDisable($('.single-shipping .shipping-form'));
}

/**
 * Show store locator when appropriate shipping method is selected
 * @param {Object} shippingForm - DOM element that contains current shipping form
 */
function showStoreFinder(shippingForm) {
  shippingForm.data('validate-hidden', false);
  shippingForm.find('input[name="storeId"]').prop('disabled', false);
  shippingForm.find('.gift').prop('checked', false);
  const checkedShippingMethod = shippingForm.find(':checked', '.shipping-method-list').val();
  let elementsToShow = '.shipping-store-selector-block';
  let elementsToHide = '.shipment-selector-block, .shipping-address__shipping-form-title, .shipping-address-block, .change-store, .gift-message-block, .gift-message, .submit-shipping';

  if (checkedShippingMethod === shippingMethodsConfig.id.DROPPOINT) {
    elementsToShow += ', .checkout-main__section-title--droppoint';
    elementsToHide += ', .checkout-main__section-title--pickup';
  } else {
    elementsToShow += ', .checkout-main__section-title--pickup';
    elementsToHide += ', .checkout-main__section-title--droppoint';
  }

  // Do not reload section if it has content and is already visible
  const $pickupInStore = shippingForm.find('.pickup-in-store');
  if ($pickupInStore.children().length === 0 || forceStoresReload) {
    $pickupInStore.empty();
    loadStoreLocator($pickupInStore);
    setForceStoresReload(false);
  }
  // hide address panel
  showElementsBySelector(elementsToShow, shippingForm[0]);
  hideElementsBySelector(elementsToHide, shippingForm[0]);
}

/**
 * Hide store finder and restore address form
 * @param {Object} shippingForm - DOM element with current form
 * @param {Object} data - data containing customer and order objects
 */
function hideStoreFinder(shippingForm, data) {
  if (data.order.usingMultiShipping) {
    $('body').trigger('instore:hideMultiShipStoreFinder', {
      form: shippingForm,
      customer: data.customer,
      order: data.order,
    });
  } else {
    $('body').trigger('instore:hideSingleShipStoreFinder', {
      form: shippingForm,
      customer: data.customer,
      order: data.order,
    });
  }

  shippingForm.data('validate-hidden', true);
  shippingForm.find('input[name="storeId"]').prop('disabled', true);

  /* Evaluate required fields and enable/disable the submit button only when the address selector is shown
  and the current customer has saved addresses */
  if (shippingForm.attr('data-address-mode') !== 'new' && data.customer.addresses && data.customer.addresses.length > 0) {
    $('.single-shipping .addressSelector').trigger('change');
  }

  hideElementsBySelector('.shipping-store-selector-block, .change-store', shippingForm[0]);
  showElementsBySelector('.gift-message-block, .submit-shipping', shippingForm[0]);
}

/**
 * Handles the initial state of single shipping on page load
 */
function handleInitialSingleship() {
  const pickupSelected = $(':checked', '.shipping-method-list').data('pickup');
  if (pickupSelected) {
    const shippingForm = $('.single-shipping .shipping-form');
    showStoreFinder(shippingForm);
  }
}

/**
 * Handles the initial state of multi-shipping on page load
 */
function handleInitialMultiship() {
  $(':checked', '.multi-shipping .shipping-method-list').each(function handleEachInitialMultiship() {
    const pickupSelected = $(this).data('pickup');
    const shippingForm = $(this).closest('form');
    const store = shippingForm.find('.store-details');
    const storeSelected = store.length;
    const storeID = storeSelected ? store.data('store-id') : null;

    if (pickupSelected && !storeSelected) {
      showStoreFinder(shippingForm);
    } else if (pickupSelected && storeSelected) {
      shippingForm
        .find('.pickup-in-store')
        ?.append(`<input type="hidden" name="storeId" value="${storeID}" />`);
      showElementsBySelector('.shipping-store-selector-block', shippingForm[0]);
      hideElementsBySelector('.submit-shipping', shippingForm[0]);
    } else {
      hideElementsBySelector('.shipping-store-selector-block', shippingForm[0]);
      showElementsBySelector('.shipping-address-block, .submit-shipping', shippingForm[0]);
    }
  });
}

/**
 * Check if the shipping method destination is an store or a droppoint where
 * customer will pick it up from
 *
 * @param {Object} shippingMethod
 * @returns {boolean}
 */
function isPickupEnabledForShippingMethod(shippingMethod) {
  return shippingMethod.dropPointEnabled || shippingMethod.storePickupEnabled;
}

function setCustomerDataIntoShippingForm() {
  const shippingForm = document.querySelector('form.shipping-form');
  const checkoutMainElement = document.getElementById('checkout-main');
  if (shippingForm
    && checkoutMainElement
    && checkoutMainElement.dataset.customerType === 'registered'
  ) {
    const shippingFormNameSelector = '[name*=_shipping_]';

    const firstNameInputElement = shippingForm.querySelector(`input${shippingFormNameSelector}[name$=_firstName]`);
    if (firstNameInputElement) {
      firstNameInputElement.value = firstNameInputElement.dataset.customerFirstname || '';
    }

    const lastNameInputElement = shippingForm.querySelector(`input${shippingFormNameSelector}[name$=_lastName]`);
    if (lastNameInputElement) {
      lastNameInputElement.value = lastNameInputElement.dataset.customerLastname || '';
    }

    const phoneBodyInputElement = shippingForm.querySelector(`input${shippingFormNameSelector}[name$=_phone]`);
    const phonePrefixInputElement = shippingForm.querySelector('select[name$=phonePrefix]');
    if (phoneBodyInputElement && phonePrefixInputElement) {
      const { 0: customerPhonePrefix, 1: customerPhoneBody } = phoneBodyInputElement.dataset.customerPhone.split(' ');
      phoneBodyInputElement.value = customerPhoneBody || '';
      phonePrefixInputElement.value = customerPhonePrefix || '';
    }
  }
}

/**
 * Check whether it must force stores reload
 * @param {Shipping} shipment Shipping model
 * @returns {boolean} True if it must force stores reload, false otherwise
 */
function mustForceStoresReload(shipment) {
  const shippingForm = $(`.shipping-form input[name="shipmentUUID"][value="${shipment.UUID}"]`)
    .closest('form');
  const pickupLayer = shippingForm.find('.pickup-in-store');
  return pickupLayer.data('url') !== shipment.pickupInstoreUrl;
}

/**
 * Updates the store finder for the shipment parameter
 * @param {Shipping} shipment Shipping model
 * @param {Object} updateCheckoutViewPayload - data from event containing customer and order objects
 */
function updateStoreFinderForShipment(shipment, updateCheckoutViewPayload) {
  const shippingForm = $(`.shipping-form input[name="shipmentUUID"][value="${shipment.UUID}"]`)
    .closest('form');
  const pickupLayer = shippingForm.find('.pickup-in-store');
  pickupLayer.data('url', shipment.pickupInstoreUrl);

  const dropPointEnabled = shipment.selectedShippingMethod?.dropPointEnabled ?? false;
  pickupLayer.data('dropPointEnabled', dropPointEnabled);
  pickupLayer.find('[name="filterByDroppoint"]').prop('checked', dropPointEnabled);

  if (isPickupEnabledForShippingMethod(shipment.selectedShippingMethod)) {
    showStoreFinder(shippingForm);
  } else {
    hideStoreFinder(shippingForm, updateCheckoutViewPayload);
  }
}

/**
 * Update the store locator checkout view for the checkout:updateCheckoutView event
 * @param {jQuery.Event} event jQuery event for checkout:updateCheckoutView
 * @param {Object} data Data object for checkout:updateCheckoutView event
 */
function updateStoreLocatorCheckoutView(event, data) {
  let shipments;
  const shipmentUUID = data.urlParams?.shipmentUUID ?? false;
  if (shipmentUUID) {
    const shipment = data.order.shipping.find((s) => s.UUID === shipmentUUID);
    shipments = [shipment];
  } else {
    if (data.order.usingMultiShipping) {
      setForceStoresReload(true);
    }
    shipments = data.order.shipping;
  }

  const anyShipmentMustForceStoresReload = shipments.some((shipment) =>
    mustForceStoresReload(shipment));
  setForceStoresReload(forceStoresReload || anyShipmentMustForceStoresReload);

  shipments.forEach((shipment) => {
    updateStoreFinderForShipment(shipment, data);
  });
}

module.exports = {
  methods: {
    setForceStoresReload,
  },
  watchForInStoreShipping() {
    $('body').on('checkout:updateCheckoutView', updateStoreLocatorCheckoutView);
  },
  watchForStoreSearch() {
    $('body').on('store-locator:search-update', () => {
      clientSideValidation.submitDisable($('.single-shipping .shipping-form'));
    });
  },
  initialStoreMethodSelected() {
    $(() => {
      const isMultiship = $('#checkout-main').hasClass('multi-ship');
      if (isMultiship) {
        handleInitialMultiship();
      } else {
        handleInitialSingleship();
      }
    });
  },
  updateAddressLabelText() {
    $('body').on('shipping:updateAddressLabelText', (e, data) => {
      const addressLabelText = isPickupEnabledForShippingMethod(data.selectedShippingMethod)
        ? data.resources.storeAddress
        : data.resources.shippingAddress;
      data.shippingAddressLabel.text(addressLabelText);
    });
  },
  changeStore() {
    $('body').on('click', '.change-store', (function changeStoreHandler(e) {
      e.preventDefault();
      e.stopPropagation();
      setForceStoresReload(true);
      showStoreFinder($(this).closest('form'));
      this[0]?.classList.add('d-none');
    }));
  },
  handleSelectStore() {
    $('body').on('change', '.select-store-input', () => {
      const $form = $('form.shipping-form');
      // const selectedStore = storeLocator.getSelectedStore();
      if (shippingHelpers.methods.isPickupMethodSelected($form[0])) {
        setCustomerDataIntoShippingForm();
        shippingHelpers.methods.submitShipping($form);
      }
    });
  },
  hideMultiShipStoreFinder() {
    $('body').on('instore:hideMultiShipStoreFinder', (e, data) => {
      if (!data.customer.registeredUser) {
        data.form.attr('data-address-mode', 'new');
      } else {
        data.form.attr('data-address-mode', 'edit');
      }
      showElementsBySelector('.shipping-address-block, .shipping-address__shipping-form-title, .shipment-selector-block', data.form[0]);
    });
  },
  hideSingleShipStoreFinder() {
    $('body').on('instore:hideSingleShipStoreFinder', (e, data) => {
      const isStoreAddress = data.order.shipping[0].shippingAddress?.title === 'Store';
      let showShippingForm = true;

      let elementsToShow = '.shipping-address__shipping-form-title';

      if (data.customer.registeredUser && data.customer.addresses.length) {
        elementsToShow += ', .shipment-selector-block';

        const selectedAddressID = isStoreAddress
          ? data.customer.preferredAddress.ID
          : data.order.shipping[0].matchingAddressId;
        const isNewAddress = !selectedAddressID;
        if (!isNewAddress) {
          showShippingForm = false;

          data.form.attr('data-address-mode', 'edit');
          const addressSelectorSelectedAddress = data.form.find(`.addressSelector input[value="ab_${selectedAddressID}"]`);
          $(addressSelectorSelectedAddress).prop('checked', true).trigger('change');
        }
      }

      if (showShippingForm) {
        if (isStoreAddress) {
          shippingHelpers.methods.selectNewAddress(data.form);
        } else {
          elementsToShow += ', .shipping-address-block';
        }
      }

      showElementsBySelector(elementsToShow, data.form[0]);
    });
  },
  actionEditMultiShip() {
    $('body').on('shipping:editMultiShipAddress', (e, data) => {
      const shippingForm = data.form;
      const pickupSelected = shippingForm.find(':checked', '.shipping-method-list').data('pickup');
      if (pickupSelected) {
        showStoreFinder(shippingForm);
      }
    });
  },
};
